import ReactKeycloakAdapter from 'all-in-one-react-keycloak/lib/ReactKeycloakAdapter';
import { ReactKeycloakProvider } from 'all-in-one-react-keycloak/lib/ReactKeycloakProvider';
import React, { ComponentProps } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { SWRDevTools } from 'swr-devtools';
import { sessionStorageService } from 'utils/SessionStorageService';
import axios from 'axios';
import App from './App';
import keycloak from './auth/keycloak';
import { initLanguage } from './i18n';
import reportWebVitals from './reportWebVitals';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import TagManager from 'react-gtm-module';
import { getConfig } from './configs';
// import LZString from 'lz-string';

type TokenLogger = ReactKeyCloakProviderProps['onTokens'];
type ReactKeyCloakProviderProps = ComponentProps<typeof ReactKeycloakProvider>;

const eventLogger: ReactKeyCloakProviderProps['onEvent'] = () => {
  // console.log('onKeycloakEvent', event, error);
};
const { baseApiUrl } = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'development');
const setTokenUrl = `${baseApiUrl}/xapi/v1/user/profile/setKeycloakTokens`;
const getTokenUrl = `${baseApiUrl}/api/v1/auth/getKeycloakTokens`;

// Cookie 工具函数
const setCookie = (
  name: string,
  value: string,
  options: { days?: number; secure?: boolean; session?: boolean } = {},
) => {
  const { days, secure = true, session = false } = options;
  // let expires = '';

  if (!session && days) {
    const date = new Date();
    // 修复点：使用 date.getTime() 获取时间戳
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    // expires = `; expires=${date.toUTCString()}`;
  }

  const secureFlag = secure ? '; Secure' : '';
  // document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Lax${secureFlag}`;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax${secureFlag}`;
};

const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }
  return null;
};

// 中间字符归前半（适合奇数长度）
const splitString = (str: string) => {
  const mid = Math.ceil(str.length / 2); // 向上取整
  return [str.slice(0, mid), str.slice(mid)];
};

const tokenLogger: TokenLogger = async (tokens) => {
  if (tokens.idToken && tokens.refreshToken) {
    try {
      // await axios.post(
      //   setTokenUrl,
      //   {
      //     auItnF1: splitString(tokens.idToken)[0],
      //     auItnS2: splitString(tokens.idToken)[1],
      //     auRtn: tokens.refreshToken,
      //   },
      //   {
      //     headers: {
      //       Authorization: 'Bearer ' + tokens.token,
      //     },
      //   },
      // );
      await axios.get(setTokenUrl, {
        headers: {
          Authorization: 'Bearer ' + tokens.token,
          'au-itn': splitString(tokens.idToken)[0],
          'au-rtn': tokens.refreshToken,
        },
        withCredentials: true,
      });
      setCookie('KeycloakTokens', splitString(tokens.idToken)[1], {
        days: 1, // Cookie 有效期 1 天
        secure: true, // 生产环境保持启用
      });
    } catch (error) {
      console.error('Error response:', error);
    }
  }
};

const auItnS2 = getCookie('KeycloakTokens');

const getToken = async () => {
  const tokens = await axios.get<{
    idToken: string;
    refreshToken: string;
    token: string;
  }>(getTokenUrl, { withCredentials: true });
  return {
    ...tokens.data,
    idToken: tokens.data.idToken + auItnS2,
  };
};
let persistedTokensString: Parameters<NonNullable<TokenLogger>>[0] = {};
// const persistedTokensString = sessionStorageService.get('KeycloakTokens');
// (async () => {
//   persistedTokensString = await getToken();
// })();

// const tokens = persistedTokensString
//   ? (JSON.parse(persistedTokensString) as Parameters<NonNullable<TokenLogger>>[0])
//   : {};
init();

async function init() {
  await initLanguage();
  const config = getConfig(process.env.REACT_APP_ENVIRONMENT);
  if (sessionStorageService.get('genbravoSessionFlag')) {
    persistedTokensString = await getToken();
  }
  const tokens = persistedTokensString ? (persistedTokensString as Parameters<NonNullable<TokenLogger>>[0]) : {};
  TagManager.initialize(config.tagManagerArgs);
  ReactDOM.render(
    <React.StrictMode>
      <SWRDevTools>
        <ReactKeycloakProvider
          initOptions={{
            ...tokens,
            adapter: ReactKeycloakAdapter,
            onLoad: 'check-sso',
            flow: 'hybrid',
            pkceMethod: 'S256',
            enableLogging: true,
          }}
          authClient={keycloak}
          onEvent={eventLogger}
          onTokens={tokenLogger}
        >
          <Router>
            <App />
          </Router>
        </ReactKeycloakProvider>
      </SWRDevTools>
    </React.StrictMode>,
    document.getElementById('root'),
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
